'use strict';
function alwaysValid() {
  return true;
}

module.exports = {
  alwaysValid: alwaysValid,
};



//////////////////
// WEBPACK FOOTER
// ./~/html-to-react/lib/is-valid-node-definitions.js
// module id = 249
// module chunks = 0